import React, { Component } from 'react';

class VeryDissatisfied extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let color = this.props.color && this.props.color!==''?this.props.color:"#1E4691";
        return(
            <React.Fragment>
                <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='hovered' d="M8.73027 14.0023C9.73381 14.0023 10.5473 12.8837 10.5473 11.5038C10.5473 10.124 9.73381 9.00537 8.73027 9.00537C7.72673 9.00537 6.91321 10.124 6.91321 11.5038C6.91321 12.8837 7.72673 14.0023 8.73027 14.0023Z" fill="white" stroke="white"/>
                    <path className='hovered' d="M18.2699 14.0023C19.2734 14.0023 20.0869 12.8837 20.0869 11.5038C20.0869 10.124 19.2734 9.00537 18.2699 9.00537C17.2663 9.00537 16.4528 10.124 16.4528 11.5038C16.4528 12.8837 17.2663 14.0023 18.2699 14.0023Z" fill="white" stroke="white"/>
                    <path d="M16.5475 9.1207L20.4464 6.61865" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path d="M6.38283 6.31885L10.1632 8.9965" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path fill="none" d="M13.4999 26.2673C20.3992 26.2673 25.9922 20.6743 25.9922 13.775C25.9922 6.87571 20.3992 1.28271 13.4999 1.28271C6.6006 1.28271 1.0076 6.87571 1.0076 13.775C1.0076 20.6743 6.6006 26.2673 13.4999 26.2673Z" stroke="white" strokeWidth="2"/>
                    <path fill="none" d="M6.91321 20.8159C6.91321 18.3071 9.86224 16.2733 13.5001 16.2733C17.1379 16.2733 20.0869 18.3071 20.0869 20.8159" stroke="white" strokeWidth="2"/>
                </svg>
                {this.props.text && this.props.text==='true'?(
                    <span>Very Dissatisfied</span>
                ):(null)}
            </React.Fragment>           
        )
    }
}
VeryDissatisfied.propTypes = {
    color: React.propTypes.node,
    text: React.propTypes.node,
}
export default VeryDissatisfied;